import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { DoctorService } from 'src/app/_service/doctor.service';
import { SharedService } from 'src/app/_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationModalComponent } from '../../common/confirmation-modal/confirmation-modal.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit {

  disableSelect: any = []; daysList: any; appointmentForm: FormGroup; submitted: boolean = false; loading: boolean = false;
  submittedOutWork: boolean = false; loadingOutWork: boolean = false; showdays: boolean = false; openRowShow: boolean = false;
  showMonday: boolean = false; showTuesday: boolean = false; showWednesday: boolean = false; showThursday: boolean = false; showFriday: boolean = false; showSaturday: boolean = false; showSunday: boolean = false;
  toggleShowhideMonday: boolean = true; toggleShowhideTuesday: boolean = true; toggleShowhideWednesday: boolean = true; toggleShowhideThursday: boolean = true; toggleShowhideFriday: boolean = true; toggleShowhideSaturday: boolean = true;
  toggleShowhideSunday: boolean = true; allDays: any = []; doctorId: any = ''; fromDate: any; toDate: any;
  appDate: any = []; appTime: any = []; checkData: any = []; unique: any = []; date_id: any = '';
  openOutWork: boolean = false; outOfworkForm: FormGroup; hidePeriodApp: boolean = true;
  hideperiodOutWork: boolean = true; outWorkData: any = []; outWork_date_id: any = ''; closeDurationOption: boolean = true; openDurationOption: boolean = false;durationForm: FormGroup;
  loadingDuration: boolean = false;appointment_duration: any ='';
  constructor(private dialog: MatDialog, private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private doctorapi: DoctorService, private sharedapi: SharedService) {

    this.appointmentForm = this.formBuilder.group({
      'from_date': [],
      'to_date': [null, Validators.required],
      appDateRange: this.formBuilder.group({
        'from_date': '',
        'to_date': ''
      }),
      'mondayTime': this.formBuilder.array([]),
      'tuesdayTime': this.formBuilder.array([]),
      'wednesdayTime': this.formBuilder.array([]),
      'thursdayTime': this.formBuilder.array([]),
      'fridayTime': this.formBuilder.array([]),
      'saturdayTime': this.formBuilder.array([]),
      'sundayTime': this.formBuilder.array([])
    });

    this.outOfworkForm = this.formBuilder.group({
      'from_date1': [],
      'to_date1': [null, Validators.required],
      OutOfWorkDateRange: this.formBuilder.group({
        'from_date1': '',
        'to_date1': ''
      }),
    });
    this.durationForm = this.formBuilder.group({
      'appointment_duration': [],
    });
    

    this.activatedRoute.params.subscribe(params => {
      if (params['doctor_id']) {
        this.doctorId = params['doctor_id'];
        this.getAppData(this.doctorId);
        this.getOutWorkData(this.doctorId);

      }
    });


  }

  get f() { return this.appointmentForm.controls; }

  get f1() { return this.outOfworkForm.controls; }


  async createAppointment() {
    // console.log(this.appointmentForm.value);

    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.appointmentForm.invalid) {
      this.loading = false;
      return;
    }
    const selectDays = [];
    if (this.appointmentForm.value.mondayTime.length > 0 && this.appointmentForm.value.mondayTime[0].monday_to_time != '') {
      selectDays.push({ 'name': 'Monday' });
    }
    if (this.appointmentForm.value.tuesdayTime.length > 0 && this.appointmentForm.value.tuesdayTime[0].tuesday_to_time != '') {
      selectDays.push({ 'name': 'Tuesday' });
    }
    if (this.appointmentForm.value.wednesdayTime.length > 0 && this.appointmentForm.value.wednesdayTime[0].wednesday_to_time != '') {
      selectDays.push({ 'name': 'Wednesday' });
    }
    if (this.appointmentForm.value.thursdayTime.length > 0 && this.appointmentForm.value.thursdayTime[0].thursday_to_time != '') {
      selectDays.push({ 'name': 'Thursday' });
    }
    if (this.appointmentForm.value.fridayTime.length > 0 && this.appointmentForm.value.fridayTime[0].friday_to_time != '') {
      selectDays.push({ 'name': 'Friday' });
    }
    if (this.appointmentForm.value.saturdayTime.length > 0 && this.appointmentForm.value.saturdayTime[0].saturday_to_time != '') {
      selectDays.push({ 'name': 'Saturday' });
    }
    if (this.appointmentForm.value.sundayTime.length > 0 && this.appointmentForm.value.sundayTime[0].sunday_to_time != '') {
      selectDays.push({ 'name': 'Sunday' });
    }

    this.appointmentForm.value.daysname = selectDays;
    this.appointmentForm.value.date_id = this.date_id;
    this.doctorId = this.activatedRoute.snapshot.paramMap.get('doctor_id');
    this.appointmentForm.value.doctor_id = parseInt(this.doctorId);
    await this.doctorapi.saveAppointment(this.appointmentForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.appointmentForm.reset();
        this.getAppData(this.doctorId);
        window.location.reload();
        this.openRowShow = false;
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  //------------out of work-------------------------//
  async createOutofWork() {
    this.submittedOutWork = true;
    this.loadingOutWork = true;
    // stop here if form is invalid
    if (this.outOfworkForm.invalid) {
      this.loadingOutWork = false;
      return;
    }

    this.outOfworkForm.value.date_id = this.outWork_date_id;
    this.doctorId = this.activatedRoute.snapshot.paramMap.get('doctor_id');
    this.outOfworkForm.value.doctor_id = parseInt(this.doctorId);
    await this.doctorapi.saveOutOfWork(this.outOfworkForm.value).subscribe((data: any) => {
      this.submittedOutWork = false;
      this.loadingOutWork = false;
      this.outWork_date_id = '';
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.outOfworkForm.reset();
        this.hideperiodOutWork = true;
        this.openOutWork = false;
        this.getOutWorkData(this.doctorId);
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }
   //------------Appointment duration-------------------------//
  async createDuration() {
    this.loadingDuration = true;
    this.doctorId = this.activatedRoute.snapshot.paramMap.get('doctor_id');
    this.durationForm.value.doctor_id = parseInt(this.doctorId);
    await this.doctorapi.save_appointment_duration(this.durationForm.value).subscribe((data: any) => {
      this.loadingDuration = false;
      if (data.status) {
        this.openDurationOption = false;
        this.closeDurationOption = true;
        this.sharedapi.presentToast(data.msg);
        this.getAppData(this.doctorId);
      } else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  ngOnInit(): void {

  }

  openRow() {
    this.openRowShow = true;
    this.hidePeriodApp = false;
  }
  hideRow() {
    this.openRowShow = false;
    this.hidePeriodApp = true;
    this.appointmentForm.reset();
  }

  dateRangeChange(date1, date2) {

    const dateRangeDays = [];
    if (date2) {
      this.fromDate = date1;
      this.toDate = date2;
      this.appointmentForm.patchValue({
        'from_date': this.fromDate,
        'to_date': this.toDate,
      })

      this.showdays = true;
      var from = new Date(this.fromDate);
      var to = new Date(this.toDate);
      var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var d = from;
      while (d <= to) {
        this.allDays = DAYS[d.getDay()]
        d = new Date(d.getTime() + (24 * 60 * 60 * 1000));//👉️ Don't remove this code.
        dateRangeDays.push(this.allDays);
      }
      this.unique = new Set(dateRangeDays);
      this.unique.forEach((element) => {
        if (element == 'Monday') {
          this.showMonday = true;
          if (this.date_id == '') {  // For Adding Time Open
            this.mondayaddQuantity();
          }
        } else if (element == 'Tuesday') {
          this.showTuesday = true;
          if (this.date_id == '') {
            this.tuesdayaddQuantity();
          }
        } else if (element == 'Wednesday') {
          this.showWednesday = true;
          if (this.date_id == '') {
            this.wednesdayaddQuantity();
          }
        } else if (element == 'Thursday') {
          this.showThursday = true;
          if (this.date_id == '') {
            this.thursdayaddQuantity();
          }
        } else if (element == 'Friday') {
          this.showFriday = true;
          if (this.date_id == '') {
            this.fridayaddQuantity();
          }
        } else if (element == 'Saturday') {
          this.showSaturday = true;
          if (this.date_id == '') {
            this.saturdayaddQuantity();
          }
        } else if (element == 'Sunday') {
          this.showSunday = true;
          if (this.date_id == '') {
            this.sundayaddQuantity();
          }
        }
      });

    }
  }
  //======================================= Monday 👇️================================================//
  mondaybookingDays(): FormArray {
    return this.appointmentForm.get("mondayTime") as FormArray
  }

  mondaynewQuantity(): FormGroup {
    return this.formBuilder.group({
      monday_from_time: '',
      monday_to_time: ''
    })
  }

  mondayaddQuantity() {
    this.mondaybookingDays().push(this.mondaynewQuantity());
    let getIndex = this.appointmentForm.controls["mondayTime"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }

  mondayremoveQuantity(i: number) {
    this.mondaybookingDays().removeAt(i);
  }
  //-------------------------------------------Tuesday 👇️----------------------------------------------------//
  tuesdaybookingDays(): FormArray {
    return this.appointmentForm.get("tuesdayTime") as FormArray
  }
  tuesdaynewQuantity(): FormGroup {
    return this.formBuilder.group({
      tuesday_from_time: '',
      tuesday_to_time: ''
    })
  }
  tuesdayaddQuantity() {
    this.tuesdaybookingDays().push(this.tuesdaynewQuantity());
    let getIndex = this.appointmentForm.controls["tuesdayTime"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }
  tuesdayremoveQuantity(i: number) {
    this.tuesdaybookingDays().removeAt(i);
  }

  //-------------------------------------------Wednesday 👇️----------------------------------------------------//
  wednesdaybookingDays(): FormArray {
    return this.appointmentForm.get("wednesdayTime") as FormArray
  }
  wednesdaynewQuantity(): FormGroup {
    return this.formBuilder.group({
      wednesday_from_time: '',
      wednesday_to_time: ''
    })
  }
  wednesdayaddQuantity() {
    this.wednesdaybookingDays().push(this.wednesdaynewQuantity());
    let getIndex = this.appointmentForm.controls["wednesdayTime"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }
  wednesdayremoveQuantity(i: number) {
    this.wednesdaybookingDays().removeAt(i);
  }


  //-------------------------------------------Thursday 👇️----------------------------------------------------//
  thursdaybookingDays(): FormArray {
    return this.appointmentForm.get("thursdayTime") as FormArray
  }
  thursdaynewQuantity(): FormGroup {
    return this.formBuilder.group({
      thursday_from_time: '',
      thursday_to_time: '',
    })
  }
  thursdayaddQuantity() {
    this.thursdaybookingDays().push(this.thursdaynewQuantity());
    let getIndex = this.appointmentForm.controls["thursdayTime"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }
  thursdayremoveQuantity(i: number) {
    this.thursdaybookingDays().removeAt(i);
  }

  //-------------------------------------------Friday 👇️----------------------------------------------------//
  fridaybookingDays(): FormArray {
    return this.appointmentForm.get("fridayTime") as FormArray
  }
  fridaynewQuantity(): FormGroup {
    return this.formBuilder.group({
      friday_from_time: '',
      friday_to_time: ''
    })
  }
  fridayaddQuantity() {
    this.fridaybookingDays().push(this.fridaynewQuantity());
    let getIndex = this.appointmentForm.controls["fridayTime"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }
  fridayremoveQuantity(i: number) {
    this.fridaybookingDays().removeAt(i);
  }

  //-------------------------------------------Saturday 👇️----------------------------------------------------//
  saturdaybookingDays(): FormArray {
    return this.appointmentForm.get("saturdayTime") as FormArray
  }
  saturdaynewQuantity(): FormGroup {
    return this.formBuilder.group({
      saturday_from_time: '',
      saturday_to_time: ''
    })
  }
  saturdayaddQuantity() {
    this.saturdaybookingDays().push(this.saturdaynewQuantity());
    let getIndex = this.appointmentForm.controls["saturdayTime"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }
  saturdayremoveQuantity(i: number) {
    this.saturdaybookingDays().removeAt(i);
  }

  //-------------------------------------------Sunday 👇️----------------------------------------------------//
  sundaybookingDays(): FormArray {
    return this.appointmentForm.get("sundayTime") as FormArray
  }

  sundaynewQuantity(): FormGroup {
    return this.formBuilder.group({
      sunday_from_time: '',
      sunday_to_time: '',
    })
  }

  sundayaddQuantity() {
    this.sundaybookingDays().push(this.sundaynewQuantity());
    let getIndex = this.appointmentForm.controls["sundayTime"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }

  sundayremoveQuantity(i: number) {
    this.sundaybookingDays().removeAt(i);
  }


  slidetoggle(event, day) {
    // console.log(event.checked);
    if (event.checked) {
      if (day == 'Monday') {
        this.toggleShowhideMonday = true;
      } else if (day == 'Tuesday') {
        this.toggleShowhideTuesday = true;
      } else if (day == 'Wednesday') {
        this.toggleShowhideWednesday = true;
      } else if (day == 'Thursday') {
        this.toggleShowhideThursday = true;
      } else if (day == 'Friday') {
        this.toggleShowhideFriday = true;
      } else if (day == 'Saturday') {
        this.toggleShowhideSaturday = true;
      } else if (day == 'Sunday') {
        this.toggleShowhideSunday = true;
      }

    } else {
      if (day == 'Monday') {
        this.toggleShowhideMonday = false;
      } else if (day == 'Tuesday') {
        this.toggleShowhideTuesday = false;
      } else if (day == 'Wednesday') {
        this.toggleShowhideWednesday = false;
      } else if (day == 'Thursday') {
        this.toggleShowhideThursday = false;
      } else if (day == 'Friday') {
        this.toggleShowhideFriday = false;
      } else if (day == 'Saturday') {
        this.toggleShowhideSaturday = false;
      } else if (day == 'Sunday') {
        this.toggleShowhideSunday = false;
      }
    }

  }

  //--------------------------------------Get Data App-----------------------------------//
  async getAppData(doctorId) {
    await this.doctorapi.getDocAppData(this.doctorId).subscribe((response: any) => {
      if (response.status) {
        this.appDate = response.date;
        this.appTime = response.time;
        this.appointment_duration= response.duration.appointment_duration + ' min ';
        this.durationForm.patchValue({
          'appointment_duration' : response.duration.appointment_duration
        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  //-----------------------------------Delete Data---------------------------------------//
  RemoveApp(dateId) {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '350px',
      backdropClass: 'backdropBackground',
      data: {
        message: 'Are you sure want to delete?',
        buttonText: {
          ok: 'Confirm',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        let data = {
          'id': dateId
        }
        this.doctorapi.deleteApp(data).subscribe((data: any) => {
          this.loading = false;
          if (data.status) {
            this.sharedapi.presentToast(data.msg);
            this.getAppData(this.doctorId);
          }
          else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.sharedapi.checkError(error);
        });

      }
    });
  }

  //-----------------------------------Edit Data---------------------------------------//
  EditApp(dateId) {
    this.patchAppData(dateId);
  }

  async patchAppData(dateId) {

    await this.doctorapi.getAppEditData(dateId).subscribe((data: any) => {
      if (data.status) {
        this.openRowShow = false;
        this.checkData = data.time;
        this.hidePeriodApp = false;
        this.date_id = data.date[2];// date_id

        this.openRowShow = true;
        this.dateRangeChange(data.date[0], data.date[1]);
        this.appointmentForm.patchValue({
          appDateRange: {
            from_date: new Date(data.date[0]),
            to_date: new Date(data.date[1])
          }
        });

        let mondayArray = this.appointmentForm.get('mondayTime') as FormArray;
        let tuesdayArray = this.appointmentForm.get('tuesdayTime') as FormArray;
        let wednesdayArray = this.appointmentForm.get('wednesdayTime') as FormArray;
        let thursdayArray = this.appointmentForm.get('thursdayTime') as FormArray;
        let fridayArray = this.appointmentForm.get('fridayTime') as FormArray;
        let saturdayArray = this.appointmentForm.get('saturdayTime') as FormArray;
        let sundayArray = this.appointmentForm.get('sundayTime') as FormArray;

        Object.keys(this.checkData).forEach(key => {
          // console.log(key); // 👉️ Days Name
          this.checkData[key].forEach((element, index) => {
            if (key == 'Monday') {
              mondayArray.push(this.formBuilder.group({
                monday_from_time: element.from_time,
                monday_to_time: element.to_time
              }));
            }
            if (key == 'Tuesday') {
              tuesdayArray.push(this.formBuilder.group({
                tuesday_from_time: element.from_time,
                tuesday_to_time: element.to_time
              }));
            }
            if (key == 'Wednesday') {
              wednesdayArray.push(this.formBuilder.group({
                wednesday_from_time: element.from_time,
                wednesday_to_time: element.to_time
              }));
            }
            if (key == 'Thursday') {
              thursdayArray.push(this.formBuilder.group({
                thursday_from_time: element.from_time,
                thursday_to_time: element.to_time
              }));
            }
            if (key == 'Friday') {
              fridayArray.push(this.formBuilder.group({
                friday_from_time: element.from_time,
                friday_to_time: element.to_time
              }));
            } if (key == 'Saturday') {
              saturdayArray.push(this.formBuilder.group({
                saturday_from_time: element.from_time,
                saturday_to_time: element.to_time
              }));
            } if (key == 'Sunday') {
              sundayArray.push(this.formBuilder.group({
                sunday_from_time: element.from_time,
                sunday_to_time: element.to_time
              }));
            }
          });

        });

      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  //-------------------- doctor Out Of Work-------------------------//

  OpenoutOfWork() {
    this.openOutWork = true;
    this.hideperiodOutWork = false;
  }
  hideoutOfWork() {
    this.openOutWork = false;
    this.hideperiodOutWork = true;
    this.outWork_date_id = '';
    this.outOfworkForm.reset();
  }
  OutOfWorkdateRangeChange(date1, date2) {
    if (date2) {
      this.fromDate = date1;
      this.toDate = date2;
      this.outOfworkForm.patchValue({
        'from_date1': this.fromDate,
        'to_date1': this.toDate,
      })
    }

  }

  async getOutWorkData(doctorId) {
    await this.doctorapi.getDocOutWorkData(this.doctorId).subscribe((response: any) => {
      if (response.status) {
        this.outWorkData = response.data;
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  EditOutWork(dateId) {
    this.patchOutWorkData(dateId);
  }

  async patchOutWorkData(dateId) {

    await this.doctorapi.getOutWorkEditData(dateId).subscribe((data: any) => {
      if (data.status) {
        this.outWork_date_id = data.date[2];//out_work_date_id
        this.openOutWork = true;
        this.hideperiodOutWork = false;
        this.OutOfWorkdateRangeChange(data.date[0], data.date[1]);
        this.outOfworkForm.patchValue({
          OutOfWorkDateRange: {
            from_date1: new Date(data.date[0]),
            to_date1: new Date(data.date[1])
          }
        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  RemoveOutOfWork(dateId) {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '350px',
      backdropClass: 'backdropBackground',
      data: {
        message: 'Are you sure want to delete?',
        buttonText: {
          ok: 'Confirm',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        let data = {
          'id': dateId
        }
        this.doctorapi.deleteOutWorkData(data).subscribe((data: any) => {
          this.loadingOutWork = false;
          if (data.status) {
            this.outWork_date_id = '';
            this.outOfworkForm.reset();
            this.openOutWork = false;
            this.sharedapi.presentToast(data.msg);
            this.getOutWorkData(this.doctorId);
          }
          else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.sharedapi.checkError(error);
        });

      }
    });
  }

  OpenDurationSection() {
    this.openDurationOption = true;
    this.closeDurationOption = false;
  }
  hideDurationOption() {
    this.openDurationOption = false;
    this.closeDurationOption = true;
  }
}
